import InvoiceItem from './InvoiceItem';

export default InvoiceItem;
